import { gsap } from 'gsap';
const id = 'backdrop'

$('body').append($(`
<div id="${id}"></div>
<style>
    #${id} {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        background-color: rgba(0,0,0, 0.3);
        transition: opacity .1s, visibility .1s;
        z-index: 10;
    }
</style>
`));


const showBackdrop = function() {
    gsap.to(`#${id}`, {autoAlpha: 1, duration: .1});
}

const hideBackdrop = function() {
    gsap.to(`#${id}`, {autoAlpha: 0, duration: .1});
}

$(`#${id}`).on('click', hideBackdrop);

export {
    showBackdrop,
    hideBackdrop
}
